import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="w-full px-4 md:px-8 py-24 flex flex-col items-center justify-center text-center min-h-[60vh]">
      <span className="w-20 h-20 flex items-center justify-center rounded-full bg-primary-50 text-primary-600 mb-6">
        <i className="ri-emotion-sad-line text-4xl"></i>
      </span>
      <h1 className="text-3xl font-bold text-foreground-950 mb-3">页面走丢了</h1>
      <p className="text-sm text-foreground-500 mb-8 max-w-md">
        你要找的页面可能已被移动或不存在，不妨回到首页继续浏览精彩的动漫内容。
      </p>
      <div className="flex items-center gap-3">
        <Link
          to="/"
          className="px-6 h-11 inline-flex items-center rounded-md bg-primary-600 text-background-50 text-sm font-medium hover:bg-primary-700 transition-colors whitespace-nowrap cursor-pointer"
        >
          返回首页
        </Link>
        <Link
          to="/anime"
          className="px-6 h-11 inline-flex items-center rounded-md border border-background-300 text-sm font-medium text-foreground-700 hover:border-primary-300 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
        >
          浏览作品库
        </Link>
      </div>
    </div>
  );
}